import { render, staticRenderFns } from "./title-row.vue?vue&type=template&id=6a1676a2&scoped=true"
import script from "./title-row.vue?vue&type=script&lang=js"
export * from "./title-row.vue?vue&type=script&lang=js"
import style0 from "./title-row.vue?vue&type=style&index=0&id=6a1676a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1676a2",
  null
  
)

export default component.exports